var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "send"
    ),
    React.createElement(
      "g",
      { stroke: "#000", strokeWidth: "1.2", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
      React.createElement("path", { d: "M2.742 12.325a.763.763 0 0 1 .054-1.334l16.829-8.616-4.07 16.66a.773.773 0 0 1-.467.533.796.796 0 0 1-.714-.062l-11.632-7.18z" }),
      React.createElement("path", { d: "M10.61 17.184l-2.328 2.328a.385.385 0 0 1-.657-.272v-3.9l12-12.965" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/send.svg